import React, { Component } from 'react';
import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { pushRollbarError } from '../../utils/rollbar';

const Error = styled.div`
    color: #f54d2e;
    text-align: center;
    .anticon-exclamation-circle {
        font-size: 30px;
        margin-bottom: 10px;
    }
`;

export default class Modal extends Component {
    state = {
        error: false
    };

    componentDidCatch(error) {
        pushRollbarError(error);
        this.setState({ error: true });
    }

    render() {
        const { ModalComponent, children, ...props } = this.props;
        const Modal = ModalComponent || AntdModal;

        return <Modal
            {...props}>
            { this.state.error ?
                <Error>
                    <ExclamationCircleOutlined />
                    <div>Не удалось отобразить данные</div>
                </Error> :
                children
            }
        </Modal>;
    }
}
